module.exports = __webpack_public_path__ + "img/medal.649ce3a0.png";